<template>
    <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
            <v-btn icon large @click="toggle" v-bind="attrs" v-on="on">
                <v-icon>mdi-filter</v-icon>
            </v-btn>
        </template>
        <span>{{ $t('filters.title') }}</span
        ><br />
        <small class=""> CTRL+ALT+F</small>
    </v-tooltip>
</template>

<script>
export default {
    methods: {
        toggle() {
            this.$bus.$emit('filterDrawer')
        },
        keydownHandler(event) {
            if (event.key == 'f' && event.ctrlKey && event.altKey) {
                this.toggle()
            }
        },
    },
    created() {
        window.addEventListener('keydown', this.keydownHandler)
    },
    beforeDestroy() {
        this.$bus.$emit('filterDrawer', false)
    },
    destroyed() {
        window.removeEventListener('keydown', this.keydownHandler)
    },
}
</script>

<style></style>
